import { gql } from '@apollo/client';

export const queryUsHts = gql`
  query UsHts($id: ID!) {
    usHts(id: $id) {
      id
      version
      number
      startDate
      endDate
      description
      rateCode
      uom
      additionalHTS
      adCvdCases {
        id
      }
      descriptions {
        startDate
        endDate
        text
      }
      mainDutyRates {
        rateCode
        adValorem
        specific
        other
        startDate
        endDate
      }
      spiRates {
        code
        country
        rateCode
        adValorem
        other
        specific
        startDate
        endDate
      }
      pga {
        startDate
        endDate
        flag
      }
      additionalHtssApplicable {
        type
        number
        startDate
        endDate
        include
        exclude
      }
      fees {
        class
        rateCode
        required
        startDate
        endDate
        rate {
          adValorem
          specific
          other
        }
      }
    }
  }
`;
